module.exports = __webpack_public_path__ + "img/ka3-1.746bd738.png";